import React from 'react'
import Header from './Header'
import BESkills from './BESkills'
// import Certifications from './Certifications'
import DBSkills from './DBSkills'
import Education from './Education'
import DevOpsSkills from './DevOpsSkills'
import ProfessionalExperience from './ProfessionalExperience'
import FESkills from './FESkills'
import AWSSkills from './AWSSkills'
import MiscSkills from './MiscSkills'

const Resume = () => {
    return (
        <section className="pt-page pt-page-2" data-id="resume">
            <Header />
            <div className="row">
                <div className="col-sm-6 col-md-12 subpage-block">
                    <ProfessionalExperience />
                </div>
                <br/>
                <div className="col-sm-6 col-md-12 subpage-block">
                    <Education />
                </div>
                {/* <div className="col-sm-6 col-md-12 subpage-block">
                    <VolunteerExperience />
                </div> */}
                {/* <div className="col-sm-6 col-md-12 subpage-block">
                    <Certifications />
                </div> */}
            </div>
            <br/>
            <div className="row">
                <div className="col-sm-6 col-md-6 subpage-block">
                    <FESkills />
                </div>
                <div className="col-sm-6 col-md-6 subpage-block">
                    <BESkills />
                </div>
            </div>
            <div className="row">
                <div className="col-sm-6 col-md-6 subpage-block">
                    <DBSkills />
                </div>
                <div className="col-sm-6 col-md-6 subpage-block">
                    <DevOpsSkills />
                </div>
            </div>
            <div className="row">
                <div className="col-sm-6 col-md-6 subpage-block">
                    <AWSSkills />
                </div>
                <div className="col-sm-6 col-md-6 subpage-block">
                    <MiscSkills />
                </div>
            </div>
        </section>
    )
}

export default Resume